import React, { lazy, Suspense } from 'react';
import ModalSpinner from '../viewers/modalSpinner';
const MediaViewer = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "@atlaskit-internal_media-viewer" */'./media-viewer-error-boundary').then(({
  MediaViewerWithErrorBoundary
}) => ({
  default: MediaViewerWithErrorBoundary
})));
export default function AsyncMediaViewer(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(ModalSpinner, null)
  }, /*#__PURE__*/React.createElement(MediaViewer, props));
}